<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="m-auto col-md-3">
      <button
        type="button"
        class="btn btn-outline-success"
        :disabled="false"
        @click="editApplication"
        style="width: 100%"
      >Сохранить</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditApplicationFormBlock',
  methods: {
    editApplication () {
      this.$emit('edit-application')
    }
  }
}
</script>
